import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";
import styles from "./messaging-template-preview-container.less";
import { MessagingTemplateContentPreview } from "@containers/messaging-template-details/messaging-template-details-component/messaging-template-preview-container/messaging-template-content-preview/messaging-template-content-preview";

type MessagingTemplatePreviewContainerProps = {
    state: FormattedMessagingTemplate;
    selectedLanguage: LocaleTypes;
};

export const MessagingTemplatePreviewContainer = (props: MessagingTemplatePreviewContainerProps) => {
    const {
        state,
        selectedLanguage
    } = props;

   

    return (
        <div className={styles.messagingTemplatePreviewContainer}>
            <div className={styles.contentPreviewHeader}>Preview</div>
           <MessagingTemplateContentPreview state={state} selectedLanguage={selectedLanguage}  />
        </div>
    );
};